import styled from 'styled-components';

const TableCell = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  flex: ${props => props.flex || 1};
  display: ${props => props.center ? 'flex' : 'block'}
  justify-content: ${props => props.center ? 'center' : 'flex-start'}
`;

export default TableCell;




// WEBPACK FOOTER //
// ./client/Dashboard/components/TableCell.js